import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogViabilityComponent } from './dialogViability.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogViabilityComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogViabilityModule {

}
